import Echarts from "echarts";
import { numConvert } from "./index";
const COLOR = ['#fb734e', '#94d96c', '#0bbcb7', '#1a9bfc', '#7049f0', '#e32f46'];

export function setColumn(data, isOnResize) {
    const { dataY, dataX, id, color = COLOR } = data;
    const myChart = Echarts.init(document.getElementById(id));

    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
            formatter: params => {
                return `${params[0].name} <br/> ${params.map(
                    item => `${item.marker} ${item.seriesName} ${item.value}% <br/>`).join('')
                    }
                `
            }
        },
        textStyle: {
            color: "#000",
            fontSize: 14
        },
        grid: {
            top: 30,
            bottom: 80
        },
        legend: {
            data: [...dataY].map(x => x.name),
            bottom: "bottom"
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14
                },
                data: dataX,
                splitLine: {
                    show: false
                },

            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} %'
                },
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false
                }
            },
        ],
        series: [...dataY].map(x => {
            return {
                name: x.name,
                type: "bar",
                data: x.data.map(item => (numConvert(item) * 100).toFixed(3)),
                barMaxWidth: '50',
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#000',
                            fontSize: '14',
                        },
                        formatter: params => params.value != 0 ? (params.value + "%") : ''
                    }
                },
            }
        }),
    }

    myChart.setOption(option);

}


export function draw(id, color) {
    var canvas = document.getElementById(id);
    var ctx = canvas.getContext('2d');
    canvas.width = '130';
    canvas.height = '130';

    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(30, 100, 60, 120);
    ctx.quadraticCurveTo(60, 120, 70, 120);
    ctx.quadraticCurveTo(100, 105, 130, 0);

    ctx.lineTo(0, 0);
    ctx.strokeStyle = color;
    ctx.stroke();
    ctx.fillStyle = color;   //填充颜色
    ctx.fill(); //填充
}

export function setYCategory(data, isOnResize) {
    const { dataY, dataX, id, color, grid } = data;
    const myChart = Echarts.init(document.getElementById(id));

    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
            formatter: params => {
                return `${params[0].name} <br/> ${params.map(
                    item => `${item.marker} ${item.seriesName} ${item.value}% <br/>`).join('')
                    }
                `
            }
        },
        textStyle: {
            color: "#000",
            fontSize: 14
        },
        grid: {
            top: 30,
            bottom: 80,
            left: 100,
            ...grid
        },
        legend: {
            data: [...dataX].map(x => x.name),
            bottom: "bottom"
        },
        xAxis: [
            {
                type: 'value',

                axisLabel: {
                    formatter: '{value} %'
                },
                splitLine: {
                    show: false
                },
            }
        ],
        yAxis: {
            type: 'category',
            splitLine: {
                show: false
            },
            axisLabel: {
                color: "black",
                fontSize: 16,
            },
            z: 10,
            data: dataY,
        },
        series: [...dataX].map(x => {
            return {
                name: x.name,
                type: "bar",
                data: x.data.map(item => (numConvert(item) * 100).toFixed(3)),
                barMaxWidth: '50',
                label: {
                    normal: {
                        show: true,
                        position: 'right',
                        textStyle: {
                            color: '#000',
                            fontSize: '14',
                        },
                        formatter: params => params.value != 0 ? (params.value + "%") : ''
                    }
                },
            }
        }),
    }

    myChart.setOption(option);

}


export const setKarte = ({
    dataX, dataY, title, type = "", id, color = COLOR, yAxis = {}
    , grid = {}, titleOption = {}
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title,
            textStyle: {
                fontSize: 20
            },
            ...titleOption
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' }
        },
        grid: {
            top: 120,
            ...grid,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name),
            textStyle: {
                fontSize: 18
            }
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,
                    interval: 0,
                },
                data: dataX
            }
        ],
        yAxis: yAxis instanceof Array ? yAxis.map(x => {
            return {
                ...x,
                type: 'value',
                name: '',
                axisLabel: {
                    formatter: type == 'perncet' ? '{value}%' : '{value}',
                },
            }
        }) : {
            ...yAxis,
            type: 'value',
            name: '',
            axisLabel: {
                formatter: type == 'perncet' ? '{value}%' : '{value}',
            },

        },
        series: dataY.map((x, i) => {
            return {
                ...x,
                name: x.name,
                type: x.type || "line",
                smooth: true,
                data: type == "percent" ? x.data.map(x => (x * 100).toFixed(1)) : x.data,
            }
        }),
    }
    myChart.setOption(option);
}

export const setOption = ({
    dataX, dataY, title, type = "", id, color = COLOR, xAxis, yAxis = {}
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    console.log(xAxis);
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title,
            textStyle: {
                fontSize: 20
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
        },
        grid: {
            top: 120,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name),
            textStyle: {
                fontSize: 18
            }
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: xAxis || [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,

                },
                data: dataX
            }
        ],
        yAxis: {
            ...yAxis,
            type: 'value',
            name: '',
            axisLabel: {
                formatter: type == 'perncet' ? '{value}%' : '{value}'
            },

        },
        series: dataY.map((x, i) => {
            return {
                name: x.name,
                type: x.type || "line",
                smooth: true,
                data: type == "percent" ? x.data.map(x => (x * 100).toFixed(1)) : x.data,
            }
        }),
    }

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/method/analysis.js